












































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '../Icon.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'

@Component({
  components: {
    LoaderWrapper,
    Icon
  },
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      // Please use mime-type extensions in order to provide correct type validation. e.g. "application/pdf" not ".pdf"
      default: '*'
    },
    type: {
      type: String
    },
    icon: {
      type: String,
      default: 'upload'
    },
    iconStyle: {
      type: String
    },
    iconSize: {
      type: Number,
      default: 16
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    validateType: {
      type: Boolean,
      default: false
    }
  }
})
export default class FileInput extends Vue {
  selectedFile: string | null = null
  idAttr: string = ''
  isError: boolean = false

  mounted () {
    this.idAttr = '_' + Math.random().toString(36).substr(2, 9)
  }

  selectFile (event: any) {
    const file = event.target.files[0]
    if (!this.validateExtension(file.type)) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Only PDF documents are allowed',
        header: 'Upload failed',
        icon: 'warning'
      })
      return
    }
    this.selectedFile = file.name
    this.$emit('select', file)
    this.$emit('change', event)
    this.isError = false
  }

  validateExtension (fileType: string): boolean {
    if (!this.$props.validateType) return true
    if (this.$props.accept === '*') return true
    return this.$props.accept.split(',').some((acceptType: string) => acceptType === fileType)
  }

  clear () {
    this.selectedFile = null
    this.isError = false
  }

  validate () {
    this.isError = !this.selectedFile
  }

  openChooseDialog () {
    (this.$refs.fileEl as any).click()
  }
}
